import styled from 'styled-components';

import { COLOR_LOADER } from '../../../globals';


export const StyledLoadingSpinner = styled.div`
  display: inherit;
  overflow: hidden;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: ${props => props.backgroundColor};

  .loader-container {
    height: 100%;
    width: 100%;
    display: table;
    position: relative;
    left: 0;
    top: 0;
  }

  .loader-content {
    border-radius: 1px;
    padding-top: 0;
    padding-left: 10%;
    padding-right: 10%;
    position: static;
    vertical-align: middle;
    display: table-cell;
  }

  .loader-spinner {
    border: ${props => props.spinnerFat}px solid #b9b6b6;
    -webkit-animation: spin 1s linear infinite;
    animation: spin 1s linear infinite;
    border-top: ${props => props.spinnerFat}px solid #555;
    border-radius: 50%;
    width: ${props => props.spinnerSize}px;
    height: ${props => props.spinnerSize}px;
    left: 50%;
    margin: 0 auto;
  }

  .loader-text {
    margin: 5px;
    color: ${COLOR_LOADER};
    text-align: center;
    font-size: ${props => props.textSize}em;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
